"use strict";
/**
 * @author jdiaz5513
 */
Object.defineProperty(exports, "__esModule", { value: true });
var int64_1 = require("./int64");
exports.Int64 = int64_1.Int64;
var uint64_1 = require("./uint64");
exports.Uint64 = uint64_1.Uint64;

//# sourceMappingURL=index.js.map
